import { render } from "./PageUsercost.vue?vue&type=template&id=1d8ca07a&scoped=true"
import script from "./PageUsercost.vue?vue&type=script&lang=js"
export * from "./PageUsercost.vue?vue&type=script&lang=js"

import "./PageUsercost.vue?vue&type=style&index=0&id=1d8ca07a&lang=css"
import "./PageUsercost.vue?vue&type=style&index=1&id=1d8ca07a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8ca07a"]])

export default __exports__